export enum AppMenus {
  Main = 'app.main-menu',
  Tool = 'app.tool-menu',
  More = 'app.more-menu',
}
